export default __webpack_public_path__ + "static/media/shop.7a83fe0e.png";